import cn from 'classnames'
import {Icon} from 'src/common/Icon'
import {MEAL_OPTIONS} from '../constants'
import type {MealKey, MealsState} from '../types'
import {CardHeader} from './CardHeader'

interface MealSelectorProps {
  meals: MealsState
  onToggle: (key: MealKey) => void
}

export const MealSelector = ({meals, onToggle}: MealSelectorProps) => (
  <div className="overflow-hidden rounded-lg border border-grey-150 bg-moss-white">
    <CardHeader step={2} label="Meals provided by employer" />
    <div className="px-6 py-8">
      <div className="space-y-2">
        {MEAL_OPTIONS.map(({key, label}) => (
          <label
            key={key}
            className="flex cursor-pointer items-center gap-3 rounded-lg border border-grey-150 px-4 py-3"
          >
            <div className="grid size-5 shrink-0 place-items-center">
              <input
                type="checkbox"
                checked={meals[key]}
                onChange={() => onToggle(key)}
                className={cn(
                  'peer size-full cursor-pointer appearance-none rounded ring-1 ring-inset ring-d9d9d9 transition-colors span-full',
                  'checked:bg-5c7168 checked:ring-0 hover:bg-d9d9d9 hover:checked:bg-5c7168',
                )}
              />
              <Icon className="size-3 scale-0 text-ffffff span-full peer-checked:scale-100" name="check-mark" />
            </div>
            <span className="text-14 text-moss-black">{label}</span>
          </label>
        ))}
      </div>
    </div>
  </div>
)
